import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { kahuluiConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={kahuluiConfig} />;
}